import React from 'react';
import Flexbox from 'flexbox-react';
import { css, cx } from 'emotion';
import ProcessUtils from 'utils/ProcessUtils';
import ProcessWizardPage from 'components/page/process/wizard/ProcessWizardPage';
import DataExplorerPage  from 'components/core/data_explorer/DataExplorerPage';
import TransformationsForm from 'components/core/forms/TransformationsForm';
import WidthParameter from 'components/core/fields/transformation_parameters/WidthParameter';
import RangeParameter from 'components/core/fields/transformation_parameters/RangeParameter';


export default class TransformationPage extends ProcessWizardPage {
    static defaultProps = {
        title: 'Define Transformation',
        description: 'Control how the process will transform your input variable data to fit each output dimension.'
    };

    renderFormWithProcess() {
        const dimensionName = this.props.pageAttributes.dimensionName;
        const coordinateSystemName = ProcessUtils.getWizardCoordinateSystemName(this.props.process);
        const transformationsFormClass = css`
            margin-bottom: 20px;
        `;
        const widthClass = css`
           .last-row-spacer {
                margin-bottom: 20px;
           }
        `;

        return (
            <DataExplorerPage
                process={this.props.process}
                siteFacilities={this.props.siteFacilities}
                exploredDatastreams={this.props.exploredDatastreams}
            >
                {this.renderDimensionHeader()}
                <Flexbox flexGrow={1} flexDirection={'column'} className={cx(this.formStyles, this.overflowContainer)}>
                    <TransformationsForm
                        dimensionName={dimensionName}
                        process={this.props.process}
                        processErrors={this.props.processErrors}
                        hasWritePermissions={this.props.hasWritePermissions}
                        coordinateSystemName={coordinateSystemName}
                        exploredDatastreams={this.props.exploredDatastreams}
                        dimensionIsTime={dimensionName === 'time'}
                        siteFacilities={this.props.siteFacilities}
                        className={transformationsFormClass}
                    />
                    <WidthParameter
                        process={this.props.process}
                        processErrors={this.props.processErrors}
                        hasWritePermissions={this.props.hasWritePermissions}
                        coordinateSystemName={coordinateSystemName}
                        dimensionName={dimensionName}
                        className={widthClass}
                    />
                    <RangeParameter
                        process={this.props.process}
                        processErrors={this.props.processErrors}
                        hasWritePermissions={this.props.hasWritePermissions}
                        coordinateSystemName={coordinateSystemName}
                        dimensionName={dimensionName}
                    />
                </Flexbox>
            </DataExplorerPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/page/process/wizard/TransformationPage.js